import React, { createContext, useContext, useState, useCallback } from 'react';

const SocketRoomsContext = createContext(null);

export function SocketRoomsProvider({ children }) {
  const [rooms, setRooms] = useState(new Set());

  const registerRooms = useCallback((roomList) => {
    setRooms((prev) => {
      const next = new Set(roomList.filter(Boolean));
      if (next.size === prev.size && [...next].every((r) => prev.has(r))) return prev;
      return next;
    });
  }, []);

  return (
    <SocketRoomsContext.Provider value={{ rooms: [...rooms], registerRooms }}>
      {children}
    </SocketRoomsContext.Provider>
  );
}

export function useSocketRooms() {
  const ctx = useContext(SocketRoomsContext);
  return ctx || { rooms: [], registerRooms: () => {} };
}
